<template>
  <ProgramaUniversidadLayout :tipo="tipo" />
</template>

<script>
import ProgramaUniversidadLayout from '@/views/pagos/layouts/ProgramaUniversidadLayout.vue';
import { TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS } from '../utils/constantes';

export default {
  name: 'ProgramaUniversidadSedeLayout',
  components: {
    ProgramaUniversidadLayout,
  },
  data() {
    return {
      tipo: TIPOS_PROGRAMAS_UNIVERSIDADES_LAYOUTS.SEDE,
    };
  },
};
</script>